import React from 'react';

import { css } from '@emotion/css';
import { DailyWorkflowRuleInfoDTO } from '@recurrency/core-api-schema/dist/dailyWorkflow/getDailyWorkflowTasks';
import { Progress } from 'antd';
import { theme } from 'theme';

import { Tooltip } from './Tooltip';

export const DailyWorkflowRuleCollapsedTooltip = ({
  task,
  color,
  children,
  reviewedItemsCount,
}: {
  task: DailyWorkflowRuleInfoDTO;
  color: string;
  children: React.ReactChild;
  reviewedItemsCount: number;
}) => {
  const totalCompleted = reviewedItemsCount + task.submittedItemLocations.length;
  const titleText = `${task.ruleName}: ${task.ruleDescription} \n ${totalCompleted} / ${task.taskCount}  reviewed`;
  const percent = totalCompleted / task.taskCount;

  const progress = () => (
    <>
      <div
        className={css`
          max-lines: 3;
          overflow: hidden;
          text-overflow: ellipsis;
        `}
      >
        {titleText}
      </div>
      <Progress
        type="line"
        percent={percent * 100}
        showInfo={false}
        strokeColor={color}
        strokeLinecap="round"
        trailColor={theme.colors.neutral[300]}
      />
    </>
  );
  return (
    <Tooltip
      title={progress}
      overlayInnerStyle={{ whiteSpace: 'pre-line', padding: 16 }}
      placement="right"
      mouseEnterDelay={0.05}
    >
      {children}
    </Tooltip>
  );
};
